
import { trackSetBudget } from '../../redux/actions/analytics';
import { EventCategory, EventDefinition, EventsMap, FilterEvent } from '../types';

const trackSetBudgetEvent: EventDefinition<any> = ({payload}) => {
  const budget: GQL.ITrackSearchBudgetFilter = payload;
  return {
    event: FilterEvent.Budget,
    category: EventCategory.SetFilter,
    action: 'set-budget',
    label: `${budget.minimum} - ${budget.maximum}`,
  };
};

export const budgetEventsMap: EventsMap = {
  [trackSetBudget.type]: trackSetBudgetEvent,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/analytics/events/budget.ts